<form [formGroup]="userForm" *ngIf="navData" class="data-wrap" fxLayout="column" data-testid="accounts-add-user">
    <div class="title" fxLayoutAlign="start center" fxLayoutGap="5px">
        <mat-icon>person</mat-icon>
        <div i18n>Add a new {{ learnerDynamicName }}</div>
    </div>
    <app-form-error
        class="error-form"
        fxFlex="0 0 100%"
        fxFlex.lt-md="1 1 100%"
        header="Error"
        i18n-header
        [messages]="error | async"
    ></app-form-error>
    <div fxLayout="column" fxLayoutGap="10px" fxLayoutAlign="start center">
        <app-user-setting-input
            type="text"
            i18n-placeholder
            placeholder="Enter first name"
            [control]="userForm.get('fname') | cast"
            testid="accounts-add-user-fname"
        >
            <label role="input-label" i18n="@@firstName">First Name*</label>
        </app-user-setting-input>

        <app-user-setting-input
            type="text"
            i18n-placeholder
            placeholder="Enter last name"
            [control]="userForm.get('lname') | cast"
            testid="accounts-add-user-lname"
        >
            <label role="input-label" i18n="@@lastName">Last Name*</label>
        </app-user-setting-input>

        <app-user-setting-input
            type="email"
            i18n-placeholder
            placeholder="Enter email address"
            [control]="userForm.get('email') | cast"
            [emailPasteFirstNameControl]="userForm.get('fname') | cast"
            [emailPasteLastNameControl]="userForm.get('lname') | cast"
            tips="This is used for login to KLMS"
            i18n-tips
            testid="accounts-add-user-email"
        >
            <label role="input-label">
                <ng-container i18n="@@email"> Email*</ng-container>
            </label>
        </app-user-setting-input>

        <div *ngIf="navData.data.user && navData.data.customer" fxLayout="column" fxLayoutGap="10px" class="w-100">
            <app-team-select-dropdown
                *ngIf="isDivisionMode"
                [user]="navData.data.user"
                formControlName="team_id"
                [customer]="navData.data.customer"
                [filters]="{ team: 1 }"
                [removable]="authUser.hasRoleHigherThan('divisionadmin')"
                [setDefaultGroup]="authUser.hasRoleHigherThan('divisionadmin') ? 'default' : 'user'"
                [DefaultGroupParams]="'team_id'"
                label="{{ learnerDynamicName }} {{ divisionDynamicName }}*"
                searchPlacholder="Search and select {{ divisionDynamicName }}"
                i18n-label
                i18n-searchPlacholder
                data-testid="accounts-add-user-team"
            >
                <ng-container *ngIf="isDivisionMode">
                    <ng-container explanation>
                        <mat-icon
                            class="third-colmn-editor-title-icon"
                            matTooltip="Selecting a {{ divisionDynamicName }} is mandatory for division mode customers."
                            i18n-matTooltip
                            >question_mark</mat-icon
                        >
                    </ng-container>
                </ng-container>
            </app-team-select-dropdown>
            <app-team-select-dropdown
                [user]="navData.data.user"
                formControlName="group_id"
                [customer]="navData.data.customer"
                [filters]="{ parent: userForm.value.team_id }"
                label="{{ learnerDynamicName }} {{ groupDynamicName }}*"
                [setDefaultGroup]="!isDivisionMode ? 'default' : null"
                searchPlacholder="Search and select {{ groupDynamicName }}"
                i18n-label
                i18n-searchPlacholder
                data-testid="accounts-add-user-group"
                [ngClass]="{
                    'disabled-input': isDivisionMode && userForm.value.team_id === null
                }"
            >
                <ng-container *ngIf="!isDivisionMode">
                    <ng-container explanation>
                        <mat-icon
                            class="third-colmn-editor-title-icon"
                            matTooltip="Selecting a {{ groupDynamicName }} is mandatory."
                            i18n-matTooltip
                            >question_mark</mat-icon
                        >
                    </ng-container>
                </ng-container>
            </app-team-select-dropdown>
        </div>

        <div
            [ngClass]="{ 'disabled-input': isDivisionMode && userForm.value.team_id === null }"
            *ngIf="navData.data.user"
            fxLayoutGap="4px"
            fxLayout="column"
            class="w-100 roles role-validity"
        >
            <span i18n>{{ learnerDynamicName }} role*</span>
            <mat-form-field class="role-field">
                <mat-select
                    fxFlex="1 1 100%"
                    placeholder="Select role"
                    i18n-placeholder
                    formControlName="role_value"
                    data-testid="accounts-add-user-role"
                >
                    <mat-option *ngFor="let role of userRoles" [value]="role.value">
                        {{ role.label }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <div *ngIf="userForm.value.role_value === 'groupadmin'">
                <span i18n>Select {{ groupDynamicName }}</span>
                <app-accounts-manager-chip-group-select
                    formControlName="managed_groups"
                    [customer_id]="navData.data.user.customer_id"
                    [params]="isDivisionMode ? { parent: userForm.value.team_id } : undefined"
                    [noGroupsAvailableMessage]="noGroupsAvailableMessage"
                ></app-accounts-manager-chip-group-select>
            </div>
            <div *ngIf="userForm.value.role_value === 'divisionadmin'" class="mt-1">
                <span i18n>Select {{ divisionDynamicName }}</span>
                <app-accounts-manager-chip-group-select
                    placeholder="Add division"
                    i18n-placeholder
                    formControlName="managed_divisions"
                    [customer_id]="navData.data.user.customer_id"
                    [params]="{ team: 1 }"
                    [noGroupsAvailableMessage]="noDivisionsAvailableMessage"
                ></app-accounts-manager-chip-group-select>
            </div>
        </div>

        <div fxLayoutGap="4px" fxLayout="column" class="w-100 notes-wrap role-validity">
            <span i18n>HR Note</span>
            <mat-form-field class="notes-form" fxFlex="0 1 100%" floatLabel="never" appearance="fill">
                <textarea
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="2"
                    cdkAutosizeMaxRows="15"
                    #input
                    matInput
                    type="text"
                    i18n-placeholder
                    placeholder="Type in your note here"
                    formControlName="notes"
                >
                </textarea>
            </mat-form-field>
        </div>
    </div>

    <div class="action" fxLayout="row-reverse wrap" fxLayoutAlign="start center" fxLayoutGap="10px">
        <ng-container *ngIf="!(loading$ | async)">
            <button
                [disabled]="userForm.invalid"
                fxFlex="0 0 auto"
                class="mobile-button custom"
                (click)="submit(true)"
                mat-raised-button
            >
                <span i18n>Create and Send</span>
            </button>
            <button
                [disabled]="userForm.invalid"
                fxFlex="0 0 auto"
                class="mobile-button positive"
                (click)="submit()"
                mat-raised-button
                data-testid="accounts-add-user-submit"
            >
                <span i18n>Create and Edit</span>
            </button>
        </ng-container>
        <app-kd-logo-loading *ngIf="loading$ | async" size="small"></app-kd-logo-loading>
        <button fxFlex="0 0 auto" class="mobile-button negative" (click)="onClose.emit(); userForm.reset()" mat-button>
            <span i18n>Cancel</span>
        </button>
    </div>
</form>
